import { Ride } from 'grids/ride/ride';
import { GridContainer } from 'libs/ui';

export const PlateRideWrapper = (props) => {
  return (
    <GridContainer>
      <Ride {...props} isPlate={true} />
    </GridContainer>
  );
};
